module.exports = __webpack_public_path__ + "static/img/15010C_2_R_20190703_LC.258039b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15010C_2_R_20190703_LC.png
// module id = eXp9
// module chunks = 0